const dashboardSelectedOperationsApprovalsReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_SELECTED_OPERATIONS_APPROVALS':
      return [...action.payload];
    default:
      return state;
  }
};

export default dashboardSelectedOperationsApprovalsReducer;
